<app-header backgroundImage="assets/header/services.webp"
            i18n-title title="Unsere Dienstleistungen"
            i18n-description
            description="Wir sind in den verschiedensten Bereichen der IT tätig. Erfahren Sie hier, wo unsere Kernkompetenzen liegen und wie wir auch Sie in Ihrem IT-Alltag unterstützen können."/>

<main>
  @for (service of services; track service.id) {
    <section>
      <div class="card card-padding shear" [id]="service.id">
        <div class="shear-inner" [class.bg-before]="$even" [class.bg-after]="$odd" [class.bg-color-after]="$odd">
          <div class="inner-content">
            <h1 class="text-center">{{ service.title }}</h1>
            <div class="row">
              <div class="col-12 col-lg-6 service">
                <h3>{{ service.subtitle }}</h3>
                <img [ngSrc]="service.image.url" [alt]="service.title"
                     [width]="service.image.intrinsicSize.width" [height]="service.image.intrinsicSize.height"
                     class="d-block d-lg-none w-100 h-auto"/>
                <p>{{ service.descriptions.full }}</p>

                <div class="accordion mt-5" [id]="`accordion${service.id}`">
                  <div class="accordion-item">
                    <div class="accordion-header">
                      <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse"
                              [attr.data-bs-target]="`#details${service.id}`" aria-expanded="false"
                              [attr.aria-controls]="`details${service.id}`">
                        {{ service.detailsButtonTitle }}
                      </button>
                    </div>
                    <div class="accordion-collapse collapse" [attr.data-bs-parent]="`#accordion${service.id}`"
                         [id]="`details${service.id}`">
                      <div class="accordion-body">
                        @for (details of service.details; track details.id) {
                          <h5>{{ details.title }}</h5>
                          <p>{{ details.description }}</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <img [ngSrc]="service.image.url" [alt]="service.title"
                   [width]="service.image.intrinsicSize.width" [height]="service.image.intrinsicSize.height"
                   class="col-12 col-lg-6 d-none d-lg-block align-self-start h-auto"/>
            </div>
          </div>
          @if (!$last) {
            <div class="edge">&nbsp;</div>
          }
        </div>
      </div>
    </section>
  }
</main>
